import React, { useEffect, useState } from 'react';
import { CheckCircle2, ShieldCheck, Lock, CreditCard, ArrowRight, Zap } from 'lucide-react';
const CHECKOUT_URL = 'https://padel-360.impultienda.ar/checkout';
const PACK_PRICE = 19;
const INCLUDED = ['Los 12 Tomos completos — todos los niveles', 'Los 6 Bonus estratégicos incluidos', '+280 páginas y +120 ejercicios graficados en cancha', 'Acceso inmediato en PDF, para siempre'];
export function PricingSection() {
  const handleCheckout = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout', {
          value: PACK_PRICE,
          currency: 'USD',
          content_name: 'Acceso Completo PADEL 360'
        });
      }
    } catch (_) {
      /* swallow */
    }
    window.location.href = CHECKOUT_URL;
  };
  // Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div id="pricing" className="w-full bg-slate-50 scroll-mt-10" data-id="element-125" data-mp="1vj7cdgmp4vzq">
      {/* SECTION 7 - PRECIO Y OFERTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-126" data-mp="k27l8oc34n7a">
        <div className="text-center mb-12" data-id="element-127" data-mp="k03c9rzbwy05">
          <p className="text-orange-600 font-heading font-bold text-xs sm:text-sm tracking-[0.2em] uppercase mb-4" data-id="element-128" data-mp="g0cozy90h00d">
            ⏰ Precio de lanzamiento — Oferta por tiempo limitado
          </p>

          {/* Countdown */}
          <div className="flex justify-center gap-3 sm:gap-5 mb-5" data-id="element-129" data-mp="mfjmpx2a4ttz">
            <TimeUnit value={timeLeft.hours} label="HS" data-id="element-130" data-mp="7k3nzeqr89r9" />
            <div className="text-3xl font-bold text-slate-300 mt-4" data-id="element-131" data-mp="7lofevhrvckw">:</div>
            <TimeUnit value={timeLeft.minutes} label="MIN" data-id="element-132" data-mp="ch3shl7yh4g9" />
            <div className="text-3xl font-bold text-slate-300 mt-4" data-id="element-133" data-mp="3uw4mqocxocky">:</div>
            <TimeUnit value={timeLeft.seconds} label="SEG" data-id="element-134" data-mp="3uutlowavhixj" />
          </div>

          <p className="text-red-600 font-bold text-sm sm:text-base" data-id="element-135" data-mp="3jbcsfybnusc">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* CHECKOUT CARD — SINGLE TICKET */}
        <div className="max-w-lg mx-auto bg-white rounded-3xl p-6 sm:p-9 border-2 border-orange-400 shadow-2xl shadow-orange-500/10" data-id="element-136" data-mp="3pxut4i6uxk1g">
          <div className="text-center mb-7" data-id="element-137" data-mp="3fz5h361n6tt4">
            <h3 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 mb-2" data-id="element-138" data-mp="3fyvqphcoqkmw">
              Acceso Completo PADEL 360
            </h3>
            <p className="text-slate-600 text-sm sm:text-base font-medium" data-id="element-139" data-mp="2sc9zf50qysh8">
              Un solo pago. Todos los Tomos y todos los Bonus incluidos.
            </p>
          </div>

          {/* What's included */}
          <ul className="space-y-3 mb-7" data-id="element-140" data-mp="31cf61cy49muc">
            {INCLUDED.map(item => <li key={item} className="flex items-start gap-3" data-id="element-141" data-mp="3g9ph4l6ukqpj">
                <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-142" data-mp="3g7urwuojmcfn" />
                <span className="text-slate-700 text-sm sm:text-base" data-id="element-143" data-mp="3bamaiwb7ycfg">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Price block */}
          <div className="rounded-2xl bg-orange-50 border border-orange-200 p-6 text-center mb-6" data-id="element-144" data-mp="3l1h82wtx0yg7">
            <p className="text-slate-400 line-through text-base font-medium" data-id="element-145" data-mp="2vccq0ed3tdh">
              USD 38
            </p>
            <p className="text-5xl sm:text-6xl font-heading font-extrabold text-slate-900 leading-none mt-1" data-id="element-146" data-mp="3tz9gdh17z5u3">
              USD <span className="text-orange-600" data-id="element-147" data-mp="lzo4x1x4vbiw">19</span>
            </p>
            <p className="text-slate-500 text-xs sm:text-sm font-medium mt-3" data-id="element-148" data-mp="lxuv5dr84b6o">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          {/* CTA */}
          <button onClick={handleCheckout} className="w-full bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-xl font-heading font-extrabold py-5 px-6 rounded-2xl shadow-xl shadow-orange-500/30 transition-all hover:scale-[1.02] flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-149" data-mp="vopof22w0b1m">
            SÍ, QUIERO MI ACCESO
            <ArrowRight className="w-5 h-5" data-id="element-150" data-mp="czsp2jsmuscj" />
          </button>

          <p className="text-center text-slate-500 text-xs sm:text-sm mt-5" data-id="element-151" data-mp="1jfl97f8xe5zd">
            El sistema elegido por profesores de pádel de toda Latinoamérica
          </p>
        </div>

        {/* Trust badges grid */}
        <div className="max-w-lg mx-auto mt-9 grid grid-cols-2 gap-x-6 gap-y-4 text-slate-600 text-xs sm:text-sm font-medium" data-id="element-152" data-mp="38wgvpg4yyvtq">
          <span className="flex items-center gap-2" data-id="element-153" data-mp="33xmbqav9n181">
            <Lock className="w-4 h-4 text-court-deep" data-id="element-154" data-mp="2z5vwbqhh1n9r" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-155" data-mp="2u7avboueazk9">
            <Zap className="w-4 h-4 text-amber-500" data-id="element-156" data-mp="2u6rob36a9vl0" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-157" data-mp="2q6r22wcy0g3e">
            <ShieldCheck className="w-4 h-4 text-court-deep" data-id="element-158" data-mp="2l6migxgqn58y" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-159" data-mp="2g7jms3mnebdn">
            <CreditCard className="w-4 h-4 text-court-deep" data-id="element-160" data-mp="2g8b90nucuwr9" /> Tarjeta ·
            Transferencia
          </span>
        </div>
      </section>

      {/* SECTION 8 - TABLA COMPARATIVA */}
      <section className="py-20 bg-court-deep px-4 sm:px-6 lg:px-8" data-id="element-161" data-mp="ef3sjb30a93s">
        <div className="max-w-5xl mx-auto" data-id="element-162" data-mp="9hbs1soapenz">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-center mb-12 text-white" data-id="element-163" data-mp="9hli1g9cblto">
            ¿Cuánto cuesta <span className="text-amber-300" data-id="element-164" data-mp="23v7fxr68uj34">NO</span> tenerlo?
          </h2>

          <div className="overflow-x-auto pb-6" data-id="element-165" data-mp="28plg06vupee4">
            <table className="w-full min-w-[600px] border-collapse" data-id="element-166" data-mp="1tze6whrqh7q3">
              <thead data-id="element-167" data-mp="1tx1h5ifqht2h">
                <tr data-id="element-168" data-mp="1yy7c7mwv9sf6">
                  <th className="w-1/3 p-4 text-left border-b border-white/15" data-id="element-169" data-mp="1yxfpz2p5t71k"></th>
                  <th className="w-1/3 p-4 text-center text-red-300 font-heading font-bold text-base sm:text-lg border-b border-white/15" data-id="element-170" data-mp="2mo1n3yxml6ws">
                    Sin PADEL 360
                  </th>
                  <th className="w-1/3 p-4 text-center text-amber-300 font-heading font-bold text-base sm:text-lg border-b border-white/15 bg-white/10 rounded-t-xl" data-id="element-171" data-mp="2dnditvy1akx3">
                    Con PADEL 360
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-172" data-mp="126n8c0mkv6xo">
                <TableRow label="Planificación semanal" bad="2 horas armando desde cero" good="5 minutos. Todo listo." data-id="element-173" data-mp="169jvm4n2br7y" />
                <TableRow label="Drills y secuencias" bad="Improvisados sin progresión" good="+120 secuencias graficadas por nivel" data-id="element-174" data-mp="yru2w344k5l7" />
                <TableRow label="Grupos mixtos" bad="Sin sistema claro" good="Estructura para cada nivel y objetivo" data-id="element-175" data-mp="18lud2je9k10s" />
                <TableRow label="Alumnos con lesiones" bad="Miedo a equivocarte" good="Protocolos listos para usar" data-id="element-176" data-mp="fxf002eozss3" />
                <TableRow label="El domingo a la noche" bad="Ansiedad y estrés" good="Planilla maestra en 15 minutos" data-id="element-177" data-mp="pqnkfohx0kpb" />
                <TableRow label="Progreso del alumno" bad="No se ve, no se mide" good="Checklist de graduación por tomo" data-id="element-178" data-mp="3tcuu4rsrkmih" />
                <TableRow label="Fidelidad del alumno" bad="Se va a los 3 meses" good="Se queda todo el año con un plan" isLast data-id="element-179" data-mp="32xkspgc2p2wg" />
              </tbody>
            </table>
          </div>

          <div className="text-center mt-12" data-id="element-180" data-mp="3gw19k03ng9sb">
            <p className="text-xl sm:text-2xl font-heading font-bold text-amber-300" data-id="element-181" data-mp="3gtokz43dz16a">
              "El lunes puedes improvisar o entrar con todo resuelto. Tú
              decides."
            </p>
          </div>
        </div>
      </section>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-182" data-mp="4ew0p7z27yzd">
      <div className="bg-court-deep text-white text-3xl sm:text-5xl font-heading font-extrabold w-[70px] h-[70px] sm:w-24 sm:h-24 flex items-center justify-center rounded-2xl shadow-lg" data-id="element-183" data-mp="4dkw55xsin77">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-slate-500 font-bold text-[11px] sm:text-xs mt-2 tracking-widest" data-id="element-184" data-mp="1xxmkm29wyi28">
        {label}
      </span>
    </div>;
}
function TableRow({
  label,
  bad,
  good,
  isLast = false
}: {
  label: string;
  bad: string;
  good: string;
  isLast?: boolean;
}) {
  return <tr data-id="element-185" data-mp="1jxbvp4s5zdjp">
      <td className={`p-5 text-white font-semibold text-sm sm:text-base ${!isLast ? 'border-b border-white/10' : ''}`} data-id="element-186" data-mp="1jxlnmxwrrus1">
        {label}
      </td>
      <td className={`p-5 text-center text-blue-200/70 text-sm sm:text-base ${!isLast ? 'border-b border-white/10' : ''}`} data-id="element-187" data-mp="2gpp5jptl8kia">
        {bad}
      </td>
      <td className={`p-5 text-center text-white font-semibold text-sm sm:text-base bg-white/10 ${!isLast ? 'border-b border-white/10' : 'rounded-b-xl'}`} data-id="element-188" data-mp="27u970vhw1h6d">
        <div className="flex items-center justify-center gap-2" data-id="element-189" data-mp="30bbtoa7g8t4b">
          <CheckCircle2 className="w-4 h-4 text-emerald-300 flex-shrink-0" data-id="element-190" data-mp="30doin7bmk3qv" />{' '}
          {good}
        </div>
      </td>
    </tr>;
}